import InputUncontrolled from "../../components/InputUncontrolled";

export default function EmergencyFields({ data, errors }) {
	return (
		<>
			<div className="two">
				<div>
					<InputUncontrolled
						type="text"
						label="First Name"
						req={true}
						name="emergencyFname"
						value={data.emergencyFname}
						errors={errors}
						autocomplete="off"
					/>
				</div>
				<div>
					<InputUncontrolled
						type="text"
						label="Last Name"
						req={true}
						name="emergencyLname"
						value={data.emergencyLname}
						errors={errors}
						autocomplete="off"
					/>
				</div>
			</div>

			<div className="two">
				<div>
					<InputUncontrolled
						type="text"
						label="Email Address"
						req={true}
						name="emergencyEmail"
						value={data.emergencyEmail}
						errors={errors}
						autocomplete="off"
					/>
				</div>
				<div>
					<InputUncontrolled
						type="text"
						label="Phone Number"
						req={true}
						name="emergencyPhone"
						value={data.emergencyPhone}
						errors={errors}
						autocomplete="off"
					/>
				</div>
			</div>
		</>
	);
}
